import { ClientsideLogger, logRefTag } from '@utils'
import { DeeplinkHandlerInput } from '.'

const logger = new ClientsideLogger('DVWbNode:deeplink')
const IFRAME_ID = 'pv-hidden-iframe'
const WINDOW_BLUR_TIMEOUT_MILLISECONDS = 1000

//Deeplink Utils
export const parseScheme = (uri: string) => {
  const matches = uri && uri.match(/^([^:]+)/)
  return (matches && matches[1]) || 'unknown'
}

const downloadFailCallback = (url: string, fallbackUrl: string) => {
  const scheme = parseScheme(url)
  if (fallbackUrl) {
    logRefTag(`dv_deeplink_${scheme}_noapp`)
    logger.count(`DVWeb::Deeplink::${scheme}::NoApp`, 1, true)
    window.location.assign(fallbackUrl)
  } else {
    logger.error('fallbackUrl param is required for deeplinking')
  }
}

const downloadSucessCallback = (url: string) => {
  const scheme = parseScheme(url)
  logRefTag(`dv_deeplink_${scheme}`)
  logger.count(`DVWeb::Deeplink::${scheme}`, 1, true)
}

const createHiddenIframe = (target: Element, uri: string) => {
  const iframe = document.createElement('iframe')
  iframe.src = uri
  iframe.id = IFRAME_ID
  iframe.style.display = 'none'
  target.appendChild(iframe)
  return iframe
}

const getHiddenIframe = (): HTMLIFrameElement =>
  document.querySelector('#' + IFRAME_ID) ||
  createHiddenIframe(document.body, 'about:blank')

const registerEvent = (
  target: Window,
  eventType: string,
  callback: () => void
) => {
  target.addEventListener(eventType, callback)
  return () => {
    target.removeEventListener(eventType, callback)
  }
}

export const deeplinkWin10Edge = ({ url, fallbackUrl }: DeeplinkHandlerInput) => {
  if (navigator.msLaunchUri) {
    navigator.msLaunchUri(
      url,
      () => downloadSucessCallback(url),
      () => downloadFailCallback(url, fallbackUrl)
    )
  }
}

export const deeplinkWin10Firefox = ({ url, fallbackUrl }: DeeplinkHandlerInput) => {
  const timeout = setTimeout(() => {
    downloadFailCallback(url, fallbackUrl)
    unregister && unregister()
  }, WINDOW_BLUR_TIMEOUT_MILLISECONDS)

  const iframe = getHiddenIframe()

  const onBlur = () => {
    clearTimeout(timeout)
    unregister && unregister()
    downloadSucessCallback(url)
  }
  const unregister = registerEvent(window, 'blur', onBlur)

  iframe.contentWindow.location.href = url
}

export const deeplinkWin10FirefoxLegacy = ({
  url,
  fallbackUrl,
}: DeeplinkHandlerInput) => {
  const iframe = getHiddenIframe()

  try {
    iframe.contentWindow.location.href = url
    downloadSucessCallback(url)
  } catch (e) {
    if (e.name === 'NS_ERROR_UNKNOWN_PROTOCOL') {
      downloadFailCallback(url, fallbackUrl)
    } else {
      logger.error('Unexpected error with Firefox deeplinking', e)
    }
  }
}

export const deeplinkWin10Chrome = ({ url, fallbackUrl }: DeeplinkHandlerInput) => {
  const timeout = setTimeout(() => {
    downloadFailCallback(url, fallbackUrl)
    unregister && unregister()
  }, WINDOW_BLUR_TIMEOUT_MILLISECONDS)

  // handle page running in an iframe
  // (blur must be registered with the top level window)
  let target: Window = window
  while (target != target.parent) {
    target = target.parent
  }

  const onBlur = () => {
    clearTimeout(timeout)
    unregister && unregister()
    downloadSucessCallback(url)
  }
  const unregister = registerEvent(target, 'blur', onBlur)

  window.location.assign(url)
}
